// Import React and Hooks
import React, { useCallback, useRef } from 'react'
// Import Redux and Hooks
import { Dispatch } from 'redux'
import { useAppDispatch } from './../../hooks/useRedux'
// Import Actions
import { showLoaderAction } from '../../actions/generalAction'
// Import Components
import OfferingImage from './OfferingImage'
import Loader from './Loader'
// Import Html to Image
import { toJpeg } from 'html-to-image'



// Download Button Props
interface downloadButtonProp {
  additionalClass?:string,
  text:string,
  functionClick?: (e:React.MouseEvent) => void
}

const DownloadButton = ( { additionalClass, text, functionClick }:downloadButtonProp ) => {



  // Use Dispatch
  const dispatch:Dispatch<any> = useAppDispatch()



  // Use Ref
  const ref = useRef<HTMLDivElement>(null)



  // Use callback
  const onButtonClick = useCallback(() => {
    console.log(ref);
    if (ref.current === null) return
    dispatch( showLoaderAction( true ) )

    toJpeg(ref.current, {
      quality: 0.75,
      cacheBust: true,
      width: ref.current.offsetWidth,
      height: ref.current.offsetHeight,
      style: {
        minWidth: `${ref.current.offsetWidth}px`,
        width: `${ref.current.offsetWidth}px`,
        maxWidth: `${ref.current.offsetWidth}px`,
        minHeight: `${ref.current.offsetHeight}px`,
        height: `${ref.current.offsetHeight}px`,
        maxHeight: `${ref.current.offsetHeight}px`,
        margin: 'unset',
        position: 'relative',
        right: 'initial',
        bottom: 'initial',
        opacity: '1'
      } })
    .then((dataUrl) => {
      console.log('start download')
      const link = document.createElement('a')
      link.download = 'my-image-name.jpg'
      link.href = dataUrl
      link.click()
    })
    .then( () => {
      dispatch( showLoaderAction( false ) )
    } )
    .catch( err => console.log(err) )
  }, [ref])



  return (
    <>
      <div className="offeringWrapper" ref={ ref } >
        <OfferingImage />
      </div>
      <button
        className={`btn btn--download ${ additionalClass ? additionalClass : ''}`}
        // onClick={ (e:React.MouseEvent) => functionClick ? functionClick(e) : null } >
        onClick={ onButtonClick } >
          <img
            src={`${window.assetsURl}/imgs/icons/download.svg`}
            alt="Icono de descargar"
            title="Icono de descargar"
            className="btn__icon" />
          { text }
      </button>
    </>
  )
}



export default DownloadButton
